import React from 'react';
import { Badge } from '@/components/ui/badge';

/**
 * Reusable Status Badge Component
 * 
 * Displays color-coded status badges for tutors and students
 */
const StatusBadge = ({ status, type = 'tutor' }) => {
  const tutorStyles = {
    'new': 'bg-blue-100 text-blue-800',
    'under_review': 'bg-yellow-100 text-yellow-800',
    'interview_scheduled': 'bg-purple-100 text-purple-800',
    'approved': 'bg-green-100 text-green-800',
    'rejected': 'bg-red-100 text-red-800',
    'onboarding_complete': 'bg-teal-100 text-teal-800',
    'pending': 'bg-yellow-100 text-yellow-800'
  };
  
  const studentStyles = {
    'new': 'bg-blue-100 text-blue-800',
    'contacted': 'bg-yellow-100 text-yellow-800',
    'matched': 'bg-purple-100 text-purple-800',
    'trial_booked': 'bg-indigo-100 text-indigo-800',
    'active': 'bg-green-100 text-green-800',
    'closed': 'bg-gray-100 text-gray-800'
  };
  
  const styles = type === 'tutor' ? tutorStyles : studentStyles;
  const label = status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  
  return (
    <Badge className={styles[status] || 'bg-gray-100 text-gray-800'}>
      {label}
    </Badge>
  );
};

export default StatusBadge;